import request from './base/api';

export function login({ account, password, recaptcha }, cb, errCb) {
  const config = {
    data: {
      account,
      password,
      recaptcha
    }
  };
  return request({
    url: 'user/login',
    method: 'post',
    cb,
    errCb,
    config
  });
}

export function logout(cb, errCb) {
  return request({
    url: 'user/logout',
    method: 'post',
    cb,
    errCb
  });
}

export function fetchUser(cb, errCb) {
  return request({
    url: 'user',
    method: 'get',
    cb,
    errCb
  });
}
export default {
  login,
  logout,
  fetchUser
};
